import React from "react";
import Reveal from "./Reveal";

export const SectionHeader = ({ overline, title, lead, align = "left", className = "" }) => (
  <div
    className={`${align === "center" ? "mx-auto text-center max-w-3xl" : "max-w-3xl"} ${className}`}
  >
    {overline && (
      <div className="tag-overline" data-testid="section-overline">
        {overline}
      </div>
    )}
    <h2
      className="heading-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold"
      data-testid="section-title"
    >
      {title}
    </h2>
    {lead && (
      <p className="mt-5 text-base sm:text-lg text-ink-600 leading-relaxed" data-testid="section-lead">
        {lead}
      </p>
    )}
  </div>
);

export const SectionWrapper = ({ id, children, alt = false, className = "" }) => (
  <section
    id={id}
    data-testid={id ? `section-${id}` : undefined}
    className={`${alt ? "bg-ink-50" : "bg-white"} border-t border-ink-200 ${className}`}
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
      <Reveal>{children}</Reveal>
    </div>
  </section>
);

export const PageHero = ({ overline, title, lead, children }) => (
  <section className="bg-white border-b border-ink-200 relative overflow-hidden">
    <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-20 lg:pt-28 pb-16 lg:pb-24">
      <Reveal>
        {overline && <div className="tag-overline">{overline}</div>}
        <h1 className="heading-display mt-4 text-4xl sm:text-5xl lg:text-6xl font-semibold max-w-4xl">
          {title}
        </h1>
        {lead && (
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-ink-600 leading-relaxed">{lead}</p>
        )}
        {children && <div className="mt-10">{children}</div>}
      </Reveal>
    </div>
  </section>
);

export const FeatureCard = ({ icon: Icon, title, children, testId }) => (
  <article
    data-testid={testId}
    className="card-hover bg-white border border-ink-200 p-7 sm:p-8 h-full"
  >
    {Icon && (
      <div className="w-10 h-10 border border-ink-200 inline-flex items-center justify-center text-cyan-600 mb-5">
        <Icon size={18} strokeWidth={1.5} />
      </div>
    )}
    <h3 className="font-display text-lg sm:text-xl font-semibold text-ink-900 tracking-tight">
      {title}
    </h3>
    <div className="mt-3 text-[15px] leading-relaxed text-ink-600">{children}</div>
  </article>
);

export const Stat = ({ label, value, hint }) => (
  <div className="border border-ink-200 p-6 bg-white">
    <div className="tag-overline">{label}</div>
    <div className="font-display text-3xl sm:text-4xl font-semibold text-ink-900 mt-3 tracking-tight">
      {value}
    </div>
    {hint && <div className="text-xs text-ink-500 mt-2">{hint}</div>}
  </div>
);
